import React from "react";

export default function Contact() {
    return <div className="contact-wrapper">
                <button className='hover-button'>
                    <span className='hover-button--off'>
                        <div>
                            <h3>Connect with me <img className="key" src={require('../images/key.svg')} alt="key"/></h3>
                        </div>
                    </span>
                    <div>
                        
                    </div>
                    <div className='hover-button--on'>
                            <div className="icon-wrapper">
                                   <a className="xcontact" href="https://msng.link/fm/evgeny.alexeev.dart">
                                    <img src={require("../images/messanger.svg")} alt="fb"></img>
                                </a>
                                <a className="xcontact" href="https://msng.link/tg/dunlop_0">
                                    <img src={require("../images/telegram.svg")} alt="tg"></img>
                                </a>
                                <a className="xcontact" href="mailto:alexeev.evghenii@gmail.com">
                                        <img src={require('../images/envelope.svg')} alt="phone"/> </a>
                                <a className="xcontact" href="tel:6046525489">
                                    <img src={require('../images/phone.svg')} alt="envelope"/></a>
                                <a className="xcontact" href="https://github.com/dunlop1">
                                    <img src={require('../images/gihub.svg')} alt="github"/></a>
                                <a className="xcontact" href="https://www.linkedin.com/in/evghenii-alexeev-05897b171/">
                                    <img src={require('../images/linkedin.svg')} alt="github"/></a>
                            </div>
                    </div>
                </button>
            </div>

}